import React from 'react';
import ApiDocsPage from './ApiDocsPage';

const Docs: React.FC = () => {
  return <ApiDocsPage />;
};

export default Docs; 